<template>
  <transition name="fade" mode="out-in">
    <div class="flex justify-center">
      <section v-if="isFetching == true" class="section horizontal center fixed-size-lg">
        <div class="sk-fading-circle">
          <div class="sk-circle1 sk-circle"></div>
          <div class="sk-circle2 sk-circle"></div>
          <div class="sk-circle3 sk-circle"></div>
          <div class="sk-circle4 sk-circle"></div>
          <div class="sk-circle5 sk-circle"></div>
          <div class="sk-circle6 sk-circle"></div>
          <div class="sk-circle7 sk-circle"></div>
          <div class="sk-circle8 sk-circle"></div>
          <div class="sk-circle9 sk-circle"></div>
          <div class="sk-circle10 sk-circle"></div>
          <div class="sk-circle11 sk-circle"></div>
          <div class="sk-circle12 sk-circle"></div>
        </div>
      </section>
      <transition-group
        id="accounts"
        v-else
        class="section horizontal justify-start overflow fixed-size-lg"
      >
        <div :ref="item.id+item.sub_id" :key="item.id+item.sub_id" v-for="item in accountList">
          <router-link :to="`/${item.id}/${item.sub_id}`" replace>
            <Item
              class="item"
              v-bind:class="[{ active: item.id + '/' + item.sub_id == activeId }]"
              v-bind:name="item.id + '/' + item.sub_id"
              v-bind:id="item.id"
              v-bind:sub_id="item.sub_id"
            />
            <div
              class="hidden item fetched active absolute"
            >This div is necessary. Otherwise classes "fetched" and "active" are removed by purgecss</div>
          </router-link>
        </div>
      </transition-group>
    </div>
  </transition>
</template>

<script>
import Item from "@/components/accounts/Item.vue";
import Placeholder from "@/components/Placeholder.vue";

export default {
  name: "Accounts",
  components: {
    Item,
    Placeholder
  },
  computed: {
    activeId() {
      return this.$route.params.id + "/" + this.$route.params.sub_id;
    },
    isFetching() {
      return this.$store.state.accounts.isFetching;
    },
    accountList() {
      return this.$store.state.accounts.list;
    }
  },
  beforeMount() {
    this.$store.dispatch("fetchAccounts");
  },
  watch: {
    accountList() {
      this.$nextTick(() => {
        if (this.isFetching == false && this.accountList.length > 0) {
          let el = this.$el.querySelector(".active");
          if (!el) return;
          let parent = this.$el.querySelector("#accounts");
          // Get the bounding rectangle so we can get the element position position
          let rect = el.getBoundingClientRect();
          // Scroll to the element (using x and y axis)

          parent.scrollTo(rect.left - window.innerWidth / 2, 0);
        }
      });
    }
  }
};
</script>

<style scoped>
section {
  z-index: 20;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
